<template>
    <el-color-picker
        ref="picker"
        :data-uuid="uuid"
        popper-class="custom-color-picker"
        :predefine="predefine"
        :disabled="disabled"
        v-model="color"
        @active-change="onColorActiveChange"
    >
    </el-color-picker>
</template>

<script>
export default {
    props: {
        value: {},
        predefine: {},
        disabled: {
            type: Boolean,
            default: false,
        },
        bestJudgementEnabled: {
            type: Boolean,
            default: false,
        },
        bestJudgement: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            uuid: uniqid(),
            bestJudgementCheckbox: null,
            color: null,
        };
    },
    created() {
        this.color = this.value;
    },
    mounted() {
        Vue.nextTick(() => {
            if (this.bestJudgementEnabled) {
                this.initBestJudgement();
            }
        });
    },
    watch: {
        value(val) {
            this.color = val;
        },
        color(val) {
            this.$emit("input", val);
        },
    },
    methods: {
        onColorActiveChange(e) {
            this.color = window.Utils.rgbToHex(e);
            $(
                `.el-color-picker[data-uuid=${this.uuid}] .el-color-picker__trigger`
            ).click();
            if (
                e &&
                this.bestJudgementCheckbox &&
                this.bestJudgementCheckbox.find("input").prop("checked")
            ) {
                this.bestJudgementCheckbox.find("input").prop("checked", false);
                this.$emit("best-judgement-changed", false);
            }
        },
        initBestJudgement() {
            let dropdown = this.$refs.picker.$children.find(
                (item) => item.$options._componentTag === "picker-dropdown"
            );
            this.bestJudgementCheckbox = $(
                `<label><input type="checkbox" name="checkbox" value="1" ${
                    this.bestJudgement ? "checked" : ""
                }>Best Judgement</label>`
            );
            $(dropdown.$el).append(this.bestJudgementCheckbox);
            this.bestJudgementCheckbox
                .find("input")
                .change(this.onChangeBestJudgement);
        },
        onChangeBestJudgement(e) {
            this.$emit("best-judgement-changed", e.target.checked);
            $(
                `.el-color-picker[data-uuid=${this.uuid}] .el-color-picker__trigger`
            ).click();
            if (e.target.checked) {
                this.color = "#FFFFFF";
            }
        },
    },
};
</script>

<style lang="scss">
.custom-color-picker {
    .el-color-dropdown__main-wrapper {
        display: none;
    }
    .el-color-dropdown__value {
        display: none;
    }
    .el-color-alpha-slider {
        display: none;
    }
    .el-color-dropdown__btns {
        display: none;
    }
    .el-color-predefine__color-selector > div {
        border: 0.5px solid black;
    }
    width: 274px !important;
}
</style>
